export const ASSIGNMENTS_FETCH_PAGE_SIZE = 100;
export const ASSIGNMENTS_FETCH_MAX_PAGES = 50;

interface AssignmentPage<TAccount> {
  accounts: Array<TAccount>;
  totalRecords: number;
}

/**
 * Walks the paginated assignments endpoint until every matching row is loaded,
 * so the assignments table can sort/filter client-side across the full set.
 */
export async function collectAssignmentPages<TAccount>(
  fetchPage: (page: number, pageSize: number) => Promise<AssignmentPage<TAccount>>,
): Promise<AssignmentPage<TAccount>> {
  const accounts: Array<TAccount> = [];
  let page = 1;
  let totalRecords = 0;

  while (page <= ASSIGNMENTS_FETCH_MAX_PAGES) {
    const result = await fetchPage(page, ASSIGNMENTS_FETCH_PAGE_SIZE);
    accounts.push(...result.accounts);
    totalRecords = result.totalRecords;

    if (result.accounts.length === 0 || accounts.length >= totalRecords) {
      break;
    }

    page += 1;
  }

  return { accounts, totalRecords };
}
